var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.465 15.136 4.632-5.723c.884-.984 1.417-2.255 1.417-3.642 0-3.123-2.698-5.654-6.026-5.654S.462 2.648.462 5.77c0 1.371.52 2.628 1.386 3.607zM6.488 2.19c1.874 0 3.394 1.42 3.394 3.172s-1.52 3.172-3.394 3.172-3.394-1.42-3.394-3.172 1.52-3.172 3.394-3.172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.836 14.036a22 22 0 0 0-2.558-.276l-.716.833c1.026.034 1.989.115 2.784.238.907.14 1.353.293 1.564.392-.21.098-.657.251-1.564.391-1.068.165-2.438.256-3.858.256h-.023c-1.412 0-2.773-.092-3.835-.256-.908-.14-1.354-.293-1.564-.391.21-.099.656-.252 1.564-.392.778-.12 1.716-.2 2.717-.236l-.729-.83c-.923.052-1.77.144-2.478.271-1.48.265-2.14.63-2.14 1.187 0 .555.66.921 2.14 1.186 1.166.21 2.71.324 4.348.324s3.182-.115 4.348-.324c1.48-.265 2.14-.63 2.14-1.186s-.66-.922-2.14-1.187"
  }))));
};
export default SvgMap;